import {
  FeedResponseSchema,
  FeedDetalheSchema,
  FeedLocaisResponseSchema,
  type FeedFilter,
  type FeedResponse,
  type FeedDetalhe,
  type FeedLocaisResponse,
} from '@lance-x/shared';
import type { ApiClient } from '../index';

/**
 * Typed wrapper over /eventos/publicos (PROFISSIONAL-only feed).
 *
 * Filter serialization:
 *   - funcoes: array → CSV ("MONTADOR,TECNICO")
 *   - todasFuncoes: boolean → '1' (presence-flag); absent when false
 *   - cidade/uf/busca/dataDe/dataAte: pass-through
 *   - page/limit: pass-through
 */
export class FeedEndpoint {
  constructor(private readonly client: ApiClient) {}

  listar(filter?: Partial<FeedFilter>): Promise<FeedResponse> {
    const query: Record<string, string | number | readonly string[] | undefined> = {};
    if (filter?.dataDe !== undefined) query['dataDe'] = filter.dataDe;
    if (filter?.dataAte !== undefined) query['dataAte'] = filter.dataAte;
    if (filter?.funcoes && filter.funcoes.length > 0) {
      query['funcoes'] = filter.funcoes;
    }
    if (filter?.todasFuncoes === true) query['todasFuncoes'] = '1';
    if (filter?.cidade !== undefined) query['cidade'] = filter.cidade;
    if (filter?.uf !== undefined) query['uf'] = filter.uf;
    if (filter?.busca !== undefined) query['busca'] = filter.busca;
    if (filter?.page !== undefined) query['page'] = filter.page;
    if (filter?.limit !== undefined) query['limit'] = filter.limit;
    return this.client.get('/eventos/publicos', {
      query,
      responseSchema: FeedResponseSchema,
    });
  }

  listarLocais(): Promise<FeedLocaisResponse> {
    return this.client.get('/eventos/publicos/locais', {
      responseSchema: FeedLocaisResponseSchema,
    });
  }

  getDetalhe(eventoId: string): Promise<FeedDetalhe> {
    return this.client.get(`/eventos/publicos/${eventoId}`, {
      responseSchema: FeedDetalheSchema,
    });
  }
}
